export default () => ({
  seller: null,
  adminSellers: null,
  summary: null,
  loading: false
})
